var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-chip',_vm._g(_vm._b({staticClass:"status-label",attrs:{"label":""}},'x-chip',Object.assign({}, _vm.$attrs, _vm.attrs),false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm._f("formatEnum")(_vm.value,_vm.enumName))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }